import { render, staticRenderFns } from "./YhPage.vue?vue&type=template&id=e23d9824&scoped=true&"
import script from "./YhPage.vue?vue&type=script&lang=js&"
export * from "./YhPage.vue?vue&type=script&lang=js&"
import style0 from "./YhPage.vue?vue&type=style&index=0&id=e23d9824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23d9824",
  null
  
)

export default component.exports